import React, { useEffect } from "react";
import useDeviceType from "../../../../global/Hooks/useDeviceType";
import { useGetLeaveCounts } from "../../../../Production/OrderArchive/Hook";
import { Box, Typography, useTheme } from "@mui/material";
import Card from "./Card";

function PersonLeaveMobile() {
  const theme = useTheme().palette.mode;
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { data } = useGetLeaveCounts(userInfo?.personId);

  return (
    <Box
      sx={{
        background: theme === "dark" ? "#262D39" : "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14)",
        borderRadius: "1rem",
        padding: "1rem",
        marginY: "1rem",
        marginX: "0.5rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography> آمارمرخصی</Typography>
      <Card>
        <Typography fontSize={"14px"}> استفاده شده در ماه</Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_UsedDailyThisMonth}
          </Typography>
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_UsedHourlyThisMonth}
          </Typography>
        </Box>
      </Card>
      <Card>
        <Typography fontSize={"14px"}> استفاده شده کل </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_TotalUsedDaily}
          </Typography>
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_TotalUsedHourly}
          </Typography>
        </Box>
      </Card>
      <Card>
        <Typography fontSize={"14px"}> مجموع باقیمانده </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_TotalRemainingDaily}
          </Typography>
          <Typography fontSize={"12px"}>یا</Typography>
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_TotalRemainingHourly}
          </Typography>
        </Box>
      </Card>
      <Card>
        <Typography fontSize={"14px"}> مجموع استحقاقی </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_TotalHaveDaily}
          </Typography>
          <Typography fontSize={"12px"}>یا</Typography>
          <Typography fontSize={"12px"}>
            {" "}
            {data?.string_TotalHaveHourly}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}

export default PersonLeaveMobile;
